module.exports = __webpack_public_path__ + "img/jewelry@2x.4f35309.jpg";